import React, { Fragment } from 'react';
import FixedBottomNavBar from '../../../../components/FixedBottomNavBar';
import { TAG_STATUS } from '../../../../constants/service/app/tagConstants';
import Button from '../../../../components/Button';
import './TagEditNavbar.scss';

const TagEditNavbar = (props) => {
  const { onSubmit, status, tagPreview, permitRegistrationTag, rejectRegistrationTag } = props;

  return (
    <FixedBottomNavBar className="tag-edit-navbar">
      <div className="button-group">
        <div className="left">
          <Button color="light" text="미리보기" onClick={() => tagPreview()} />
        </div>

        <div className="right">
          {status === TAG_STATUS.confirmReady ? (
            <Fragment>
              <Button color="primary" text="승인하기" onClick={() => permitRegistrationTag()} />

              <Button color="light" text="승인거절" onClick={() => rejectRegistrationTag()} />
            </Fragment>
          ) : (
            <Button color="primary" text="저장" onClick={() => onSubmit()} />
          )}
        </div>
      </div>
    </FixedBottomNavBar>
  );
};

export default TagEditNavbar;
